import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const QualityMedalFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M17.1379 4.35895C19.9035 7.12456 20.0524 11.7951 16.8992 14.7607L19.1695 20.3133L15.5475 19.4132L13.6228 22.6108L12.0211 18.6931L10.3773 22.6151L8.45257 19.4174L4.83044 20.3175L7.11486 14.8674C3.95348 12.0001 4.09779 7.21666 6.91723 4.39722C9.73667 1.57779 14.3723 1.59336 17.1379 4.35895ZM8.87994 8.72985L10.9399 10.7899L15.1199 6.60986L16.28 7.76989L10.9399 13.1099L7.71997 9.86987L8.87994 8.72985Z"
      />
    </SvgIcon>
  );
});
